import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Modal from 'react-modal';

import GrapheXT from '../Graphe/AffichageGraphe/GrapheXT/GrapheXT';
import ChangementIntervalTempsGrapheAutomatique from '../Graphe/AffichageGraphe/ChangementEchantillonGrapheAutomatiqueXT/ChangementIntervalTempsGrapheAutomatique';
import ChangementIntervalTempsGraphe from '../Graphe/AffichageGraphe/ChangementEchantillonGraphe/ChangementEchantillonGraphe';
import Bouton from '../UI/Bouton/Bouton';
import AttenteRequete from '../../hoc/AttenteRequete/AttenteRequete';
import AccesRestreins from '../../hoc/AccesRestreins/AccesRestreins';

import { checkMot } from '../../ressources/functionJS/checkMot';
import * as actions from '../../services/actions';
import * as requestType from '../../ressources/glossaires/glossaire_requetes';
import * as glossaire_type_export from '../../ressources/glossaires/glossaire_type_export';
import * as privilege from '../../ressources/glossaires/glossaire_privileges';

import S from './ExportImpressionEcran.module.scss';
import AffichageVue from '../Vue/AffichageVue/AffichageVue';
import { checkPhrase } from '../../ressources/functionJS/checkPhrase';
import SwitchGraphe from '../Graphe/AffichageGraphe/SwitchGraphe';

const ExportImpressionEcran = () => {
  const dispatch = useDispatch();

  const [afficherModifierIntervalle, setAfficherModifierIntervalle] =
    useState(false);
  const [dimensionWidthGraphe, setDimensionWidthGraphe] = useState(
    window.innerWidth - 55
  );
  const [dimensionHeightGraphe, setDimensionHeightGraphe] = useState(
    window.innerHeight - 25
  );
  const [modalClassName, setModalClassName] = useState('');

  const reConnexion = useSelector((state) => state.authentifie.reConnexion);
  const donneesGraphe = useSelector(
    (state) => state.graphe.liste_donnees_graphes
  );
  const type_affichage = useSelector(
    (state) => state.exportImpressionEcran.type_affichage
  );
  const iD_objet_affichage = useSelector(
    (state) => state.exportImpressionEcran.iD_objet_affichage
  );
  const intervalle_objet_affichage = useSelector(
    (state) => state.exportImpressionEcran.intervalle_objet_affichage
  );
  const attenteReq_recuperation_des_donnees_d_un_graphe = useSelector(
    (state) =>
      state.attenteRequete[
        'ATTENTE_REQUETE' + requestType.recuperation_des_donnees_d_un_graphe
      ]
  );

  const switchAfficherModifierIntervalle = () => {
    setAfficherModifierIntervalle((prev) => !prev);
  };

  // Memoize handleResize to avoid unnecessary effect re-runs
  const handleResize = React.useCallback(() => {
    setDimensionWidthGraphe(window.innerWidth - 55);
    setDimensionHeightGraphe(window.innerHeight - 75);
  }, []);

  const reqRecupererDonneesGrapheAvecNDerniereValeurs = (
    idGraphe,
    measures_num
  ) => {
    dispatch(
      actions.reqRecupererDonneesGraphe(
        idGraphe,
        null,
        measures_num,
        [],
        [null, null]
      )
    );
  };

  const reqRecupererDonneesGrapheAvecIntervalle = React.useCallback(
    (idGraphe, debut, fin) => {
      dispatch(
        actions.reqRecupererDonneesGraphe(
          idGraphe,
          null,
          null,
          [],
          [debut, fin]
        )
      );
    },
    [dispatch]
  );

  const reqRecupererDonneesGraphe = React.useCallback(
    (idGraphe) => {
      dispatch(actions.reqRecupererDonneesGraphe(idGraphe));
    },
    [dispatch]
  );

  const reqRecupererDonneesGrapheAutomatiqueXT = React.useCallback(
    (sensor_id, position_in_sensor) => {
      dispatch(
        actions.reqRecupererDonneesGrapheAutomatiqueXT(
          sensor_id,
          position_in_sensor,
          null,
          null,
          [],
          [null, null]
        )
      );
    },
    [dispatch]
  );

  const reqRecupererDonneesGrapheAutomatiqueXTAvecIntervalle =
    React.useCallback(
      (sensor_id, position_in_sensor, debut, fin) => {
        dispatch(
          actions.reqRecupererDonneesGrapheAutomatiqueXT(
            sensor_id,
            position_in_sensor,
            null,
            null,
            [],
            [debut, fin]
          )
        );
      },
      [dispatch]
    );

  useEffect(() => {
    if (!type_affichage) return;

    if (type_affichage === glossaire_type_export.graphe) {
      if (intervalle_objet_affichage) {
        const [debut, fin] = intervalle_objet_affichage.split('_').map(Number);
        reqRecupererDonneesGrapheAvecIntervalle(
          Number(iD_objet_affichage),
          debut,
          fin
        );
      } else {
        reqRecupererDonneesGraphe(Number(iD_objet_affichage));
      }
      setModalClassName(S.ModalGraphe);
    } else if (type_affichage === glossaire_type_export.graphe_automatique) {
      const [sensor_id, position_in_sensor] = iD_objet_affichage
        .split('_')
        .map(Number);
      if (intervalle_objet_affichage) {
        const [debut, fin] = intervalle_objet_affichage.split('_').map(Number);
        reqRecupererDonneesGrapheAutomatiqueXTAvecIntervalle(
          sensor_id,
          position_in_sensor,
          debut,
          fin
        );
      } else {
        reqRecupererDonneesGrapheAutomatiqueXT(sensor_id, position_in_sensor);
      }
      setModalClassName(S.ModalGraphe);
    } else if (type_affichage === glossaire_type_export.visualisation) {
      setModalClassName(S.ModalVisualisation);
    }
  }, [
    type_affichage,
    intervalle_objet_affichage,
    iD_objet_affichage,
    reqRecupererDonneesGraphe,
    reqRecupererDonneesGrapheAvecIntervalle,
    reqRecupererDonneesGrapheAutomatiqueXT,
    reqRecupererDonneesGrapheAutomatiqueXTAvecIntervalle,
  ]);

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [handleResize]);

  // Connexion no longer mounts on this route, so trigger the initial auth check ourselves
  useEffect(() => {
    dispatch(actions.demandeInformationDeConnexion());
  }, [dispatch]);

  let affichageObjetExport;
  let affichageComposantChangementInterval = null;
  switch (type_affichage) {
    case glossaire_type_export.graphe:
      if (
        donneesGraphe[iD_objet_affichage] !== undefined &&
        donneesGraphe[iD_objet_affichage].config !== undefined
      ) {
        let boolAfficherGraphe = true;
        for (
          let indSetDonnees = 0;
          indSetDonnees < donneesGraphe[iD_objet_affichage].length;
          indSetDonnees
        ) {
          if (
            donneesGraphe[iD_objet_affichage][indSetDonnees].t !== undefined &&
            donneesGraphe[iD_objet_affichage][indSetDonnees].t !== null &&
            donneesGraphe[iD_objet_affichage][indSetDonnees].t.length > 0
          ) {
            boolAfficherGraphe = false;
            break;
          }
        }
        if (boolAfficherGraphe) {
          affichageObjetExport = (
            <SwitchGraphe
              graph_id={iD_objet_affichage}
              donneesGraphe={donneesGraphe[iD_objet_affichage]}
              switchAfficherModifierIntervalle={
                switchAfficherModifierIntervalle
              }
              dimensionWidth={dimensionWidthGraphe}
              dimensionHeight={dimensionHeightGraphe}
              configuration={donneesGraphe[iD_objet_affichage].config}
              donnees={donneesGraphe[iD_objet_affichage].data}
              seuils={
                donneesGraphe[iD_objet_affichage].alarms_levels !== undefined
                  ? donneesGraphe[iD_objet_affichage].alarms_levels
                  : []
              }
              reqRecupererDonneesGraphe={reqRecupererDonneesGraphe}
              reqRecupererDonneesGrapheAvecNDerniereValeurs={
                reqRecupererDonneesGrapheAvecNDerniereValeurs
              }
              attenteReq_recuperation_des_donnees_d_un_graphe={
                attenteReq_recuperation_des_donnees_d_un_graphe
              }
            />
          );
          affichageObjetExport = (
            <AccesRestreins
              numPrivilege={privilege.recuperer_la_liste_des_graphes}
            >
              <AttenteRequete
                request_type={requestType.recuperation_des_donnees_d_un_graphe}
                str={checkMot('en_cour_de_reception_des_donnees_du_graphe')}
              >
                {affichageObjetExport}
              </AttenteRequete>
            </AccesRestreins>
          );
          affichageComposantChangementInterval = (
            <ChangementIntervalTempsGraphe
              graph_id={iD_objet_affichage}
              afficherPopup={afficherModifierIntervalle}
              fermerPopupModifierIntervalle={switchAfficherModifierIntervalle}
            />
          );
        } else {
          affichageObjetExport = 'Erreur données API non conforme.';
        }
      } else {
        affichageObjetExport = (
          <Bouton
            ajoutClass={S.style}
            cliquer={() => {
              reqRecupererDonneesGraphe(iD_objet_affichage);
            }}
          >
            {checkMot('refresh')}
          </Bouton>
        );
      }
      break;
    case glossaire_type_export.graphe_automatique:
      const listeId = iD_objet_affichage.split('_');
      const sensor_id = parseInt(listeId[0]);
      const position_in_sensor = parseInt(listeId[1]);
      if (
        donneesGraphe[sensor_id + '+' + position_in_sensor] !== undefined &&
        donneesGraphe[sensor_id + '+' + position_in_sensor].config !== undefined
      ) {
        const titre_graphe =
          donneesGraphe[sensor_id + '+' + position_in_sensor].config.title;
        affichageObjetExport = (
          <AccesRestreins
            numPrivilege={privilege.recuperer_la_liste_des_graphes}
          >
            <AttenteRequete
              request_type={
                requestType.recuperation_des_donnees_d_un_graphe_automatique_xt
              }
              str={checkMot(
                'en_cour_de_reception_des_donnees_du_graphe_automatique'
              )}
            >
              <GrapheXT
                donneesGraphe={
                  donneesGraphe[sensor_id + '+' + position_in_sensor]
                }
                dimensionWidth={dimensionWidthGraphe}
                dimensionHeight={dimensionHeightGraphe}
                switchAfficherModifierIntervalle={
                  switchAfficherModifierIntervalle
                }
                configuration={{
                  ...donneesGraphe[sensor_id + '+' + position_in_sensor].config,
                  title: checkPhrase(
                    'traduction_titre_graphe_automatique',
                    titre_graphe.substring(21, titre_graphe.length - 21)
                  ),
                }}
                donnees={
                  donneesGraphe[sensor_id + '+' + position_in_sensor].data
                }
                seuils={
                  donneesGraphe[sensor_id + '+' + position_in_sensor]
                    .alarms_levels
                }
              />
            </AttenteRequete>
          </AccesRestreins>
        );
        affichageComposantChangementInterval = (
          <ChangementIntervalTempsGrapheAutomatique
            sensor_id={sensor_id}
            position_in_sensor={position_in_sensor}
            afficherPopup={afficherModifierIntervalle}
            fermerPopupModifierIntervalle={switchAfficherModifierIntervalle}
          />
        );
      } else {
        affichageObjetExport = (
          <Bouton
            ajoutClass={S.style}
            cliquer={() => {
              reqRecupererDonneesGrapheAutomatiqueXT(
                sensor_id,
                position_in_sensor
              );
            }}
          >
            {checkMot('refresh')}
          </Bouton>
        );
      }
      break;
    case glossaire_type_export.visualisation:
      affichageObjetExport = (
        <AffichageVue
          view_id={parseInt(iD_objet_affichage)}
          uniciteVue={checkMot('export')}
        />
      );
      break;
    default:
      break;
  }

  return (
    <Modal
      isOpen={reConnexion}
      style={{
        overlay: {
          position: 'absolute',
          zIndex: '250',
          border: 'black 1px solid',
          backgroundColor: 'transparent',
          transition: 'width 2s, height 4s',
        },
        content: {
          inset: '0% 0% 0% 0%',
          boxShadow: '-5px 0px 5px rgba(0, 0, 0, 0.226)',
        },
      }}
      className={modalClassName}
    >
      {affichageObjetExport}
      {affichageComposantChangementInterval}
    </Modal>
  );
};

export default ExportImpressionEcran;
